import { useSelector } from "react-redux";
import { useEffect, useRef } from "react";
import { getSelectedQueryModal } from "redux/SingleDataset/selectors";
import styles from "./style.module.scss";
import { useQueryModal } from "../../../../../hooks/UseQueryModal/useQueryModal";

export default function QueryModalWrapper() {
  const selectedQueryModalData = useSelector((state) =>
    getSelectedQueryModal(state),
  );
  const modalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const position = selectedQueryModalData?.position || null;
    if (modalRef.current && position) {
      modalRef.current.style.setProperty("--modal-top", `${position.top}px`);
      modalRef.current.style.setProperty("--modal-left", `${position.left}px`);
      modalRef.current.style.setProperty(
        "--modal-align",
        position.align === "end" ? "-100%" : "0",
      );
    }
  }, [selectedQueryModalData]);

  const modal = useQueryModal();

  if (
    !selectedQueryModalData ||
    !selectedQueryModalData.position ||
    selectedQueryModalData.fromSearch
  ) {
    return <noscript />;
  }

  const wrapperClass = styles.modalPositioner;

  return (
    <div ref={modalRef} className={wrapperClass}>
      {modal}
    </div>
  );
}
